import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

export interface PlanUsage {
  plan: string;
  plan_name: string;
  limits: { max_users: number | null; max_published_listings: number | null };
  usage: { users: number; published_listings: number };
}

export function useUsage(organizationId: string | null | undefined) {
  return useQuery({
    queryKey: ["billing", "usage", organizationId],
    enabled: Boolean(organizationId),
    queryFn: async () => {
      const { data, error } = await apiClient.GET(
        "/api/v1/organizations/{organization_id}/usage",
        { params: { path: { organization_id: organizationId! } } },
      );
      if (error || !data) throw new Error("Failed to load plan usage");
      return data as unknown as PlanUsage;
    },
  });
}
